import { useEnv } from '../../../../context/env-context';
import { useSite } from '../../../../context/page-context';
import { PlanDisplay } from './plan-display';

export function PendingPlan() {
  const env = useEnv();
  const { teamId } = useSite();

  // @todo: test this for other platforms
  // We navigate the user to app.sparklayer.io/dashboard-api/teams/${teamId}/billing/confirm-plan to confirm their plan
  // However it is unclear if this will work on Wix and Shopify
  const confirmPlanURL = `/dashboard-api/teams/${teamId}/billing/confirm-plan`;

  if (!env.billing.has_pending_plan || !env.billing.pending_plan) {
    return;
  }

  return (
    <PlanDisplay
      name={env.billing.pending_plan.billing_plan.public_name}
      billingDuration={env.billing.pending_plan.duration}
      billingProvider={env.billing.pending_plan.billing_provider_name}
      price={env.billing.pending_plan.billing_plan.price}
      ordersAllowed={env.billing.pending_plan.billing_plan.orders_allowed}
      salesAgentsAllowed={env.billing.pending_plan.billing_plan.sales_agents_allowed}
      isEnterprise={false}
      pending
      confirmPlan={confirmPlanURL}
    />
  );
}
